import { ModuleKind, ScriptTarget, transpileModule } from "typescript";
/**
 * Transpile TypeScript using `transpileModule` from the TypeScript compiler API.
 * `tsCode` will be transformed to JavaScript *without* syntax or type checking.
 *
 * @param tsCode - TypeScript code to transpile
 * @return TranspileOutput - Object containing the JavaScript code, source map, and diagnostics
 *
 * @note `transpileModule` ignores many compiler options, such as
 * `noEmitOnError`. Check its implementation to make sure it works for your use
 * case.
 */
export function transpileToJavascript(tsCode) {
    const compilerOptions = {
        allowJs: true,
        target: ScriptTarget.ES2018,
        lib: ["ES2018"],
        module: ModuleKind.CommonJS,
    };
    const jsCode = transpileModule(tsCode, { reportDiagnostics: true, compilerOptions });
    return jsCode;
}
//# sourceMappingURL=transpileToJavascript.js.map